const STORAGE_KEY = 'projectListFilters';

export interface FilterOption {
  id: string | number;
  name: string;
  [key: string]: any;
}

export interface SortConfig {
  key: string;
  direction: string;
}

export interface ProjectListFilters {
  searchTerm: string;
  selectedAIFMType: FilterOption | null;
  selectedAssignee: FilterOption | null;
  sortConfig: SortConfig;
}

const getDefaultFilters = (): ProjectListFilters => ({
  searchTerm: '',
  selectedAIFMType: null,
  selectedAssignee: null,
  sortConfig: { key: '', direction: '' }
});

const isOption = (value: any): value is FilterOption =>
  !!value &&
  typeof value === 'object' &&
  (typeof value.id === 'string' || typeof value.id === 'number') &&
  typeof value.name === 'string';

// The report type filter is sent to the API by `key`, so an option without one is not restorable.
const isReportTypeOption = (value: any): value is FilterOption =>
  isOption(value) && typeof value.key === 'string';

export const loadProjectListFilters = (): ProjectListFilters => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return getDefaultFilters();
    const parsed = JSON.parse(raw);
    return {
      searchTerm: typeof parsed?.searchTerm === 'string' ? parsed.searchTerm : '',
      selectedAIFMType: isReportTypeOption(parsed?.selectedAIFMType)
        ? parsed.selectedAIFMType
        : null,
      selectedAssignee: isOption(parsed?.selectedAssignee) ? parsed.selectedAssignee : null,
      sortConfig:
        typeof parsed?.sortConfig?.key === 'string' &&
        typeof parsed?.sortConfig?.direction === 'string'
          ? { key: parsed.sortConfig.key, direction: parsed.sortConfig.direction }
          : getDefaultFilters().sortConfig
    };
  } catch {
    return getDefaultFilters();
  }
};

export const saveProjectListFilters = (filters: ProjectListFilters) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
  } catch {
    // Storage can be unavailable or full; persistence is best-effort.
  }
};

export const clearProjectListFilters = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clear if storage is unavailable.
  }
};
